import {
  GET_PRODUCT_DETAIL_LIST_REQUEST,
  GET_PRODUCT_DETAIL_LIST_RESPONSE,
  GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_REQUEST,
  GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_RESPONSE,
  ADD_PRODUCT_DETAIL_REQUEST,
  ADD_PRODUCT_DETAIL_RESPONSE,
  UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
  UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
  DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
  DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
  UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_REQUEST,
  UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_RESPONSE,
  GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
  DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
  SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_REQUEST,
  SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_RESPONSE,
  SET_PRODUCT_CATEGORY_ID,
} from "./actionTypes";

export const getProductDetailListRequest = () => {
  return {
    type: GET_PRODUCT_DETAIL_LIST_REQUEST,
  };
};

export const getProductDetailListResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_DETAIL_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const getProductDetailListByProductCategoryIdRequest = (
  productCategoryId
) => {
  return {
    type: GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_REQUEST,
    payload: { productCategoryId },
  };
};

export const getProductDetailListByProductCategoryIdResponse = (
  apiResponse
) => {
  return {
    type: GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const addProductDetailRequest = (data) => {
  return {
    type: ADD_PRODUCT_DETAIL_REQUEST,
    payload: { data },
  };
};

export const addProductDetailResponse = (apiResponse) => {
  return {
    type: ADD_PRODUCT_DETAIL_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductDetailByProductDetailIdRequest = (
  productDetailId,
  data
) => {
  return {
    type: UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId, data },
  };
};

export const updateProductDetailByProductDetailIdResponse = (apiResponse) => {
  return {
    type: UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductDetailStatusByProductDetailIdRequest = (
  productDetailId,
  status
) => {
  return {
    type: UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId, status },
  };
};

export const updateProductDetailStatusByProductDetailIdResponse = (
  apiResponse
) => {
  return {
    type: UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteProductDetailByProductDetailIdRequest = (
  productDetailId
) => {
  return {
    type: DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId },
  };
};

export const deleteProductDetailByProductDetailIdResponse = (apiResponse) => {
  return {
    type: DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const getProductImagesByProductDetailIdRequest = (productDetailId) => {
  return {
    type: GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId },
  };
};

export const getProductImagesByProductDetailIdResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductImagesByProductDetailIdRequest = (
  productDetailId,
  data
) => {
  return {
    type: UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId, data },
  };
};

export const updateProductImagesByProductDetailIdResponse = (apiResponse) => {
  return {
    type: UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteProductImagesByProductDetailIdRequest = (
  productDetailId,
  data
) => {
  return {
    type: DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST,
    payload: { productDetailId, data },
  };
};

export const deleteProductImagesByProductDetailIdResponse = (apiResponse) => {
  return {
    type: DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const setDefaultImageForProductDetailRequest = (
  productDetailId,
  productImageName
) => {
  return {
    type: SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_REQUEST,
    payload: { productDetailId, productImageName },
  };
};

export const setDefaultImageForProductDetailResponse = (apiResponse) => {
  return {
    type: SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_RESPONSE,
    payload: { apiResponse },
  };
};

export const setProductCategoryId = (id) => ({
  type: SET_PRODUCT_CATEGORY_ID,
  payload: { id },
});
